import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=021cc274"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021cc274')) {
      api.createRecord('021cc274', component.options)
    } else {
      api.reload('021cc274', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=021cc274", function () {
      api.rerender('021cc274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Analytics/ReconciliationCard/Loader.vue"
export default component.exports